import { Linking, Platform } from 'react-native';

/**
 * Opens an external URL — a new tab on web, the system handler on native.
 */
export function openExternalUrl(url: string): void {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  void Linking.openURL(url);
}
